module.exports = __webpack_public_path__ + "static/media/linen.1b48a97d.jpg";